import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence } from "motion/react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import PageTransition from "@/components/PageTransition";

export default function RootLayout() {
  const location = useLocation();

  return (
    <div className="relative z-[2] flex min-h-screen flex-col">
      <ScrollToTop />
      <Header />
      {/* Extra top space on mobile for fixed header nav + language row. */}
      <main className="relative flex-1 pt-[7.25rem] sm:pt-20">
        <AnimatePresence mode="wait">
          <PageTransition key={location.pathname}>
            <Outlet />
          </PageTransition>
        </AnimatePresence>
      </main>
      <Footer />
    </div>
  );
}
